// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Современный карточный дизайн */
.lXP0bWPL5ESHwJzG_h7X {
    margin-bottom: 12px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.12);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: move;
    border: 1px solid #f0f0f0;
}

.lXP0bWPL5ESHwJzG_h7X:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
    transform: translateY(-1px);
    border-color: #d9d9d9;
}

.sfJNS4IUruQQ0jXHttPI {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

._ghhA8P__OyCGB4hZ8cV {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.h3szAdLROrv29YHjSwO6 {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.xP9yEveWlOy8IJfoujdA {
    color: #bfbfbf;
    cursor: grab;
    margin-right: 8px;
    transition: color 0.2s ease;
}

.xP9yEveWlOy8IJfoujdA:hover {
    color: #8c8c8c;
}

.xP9yEveWlOy8IJfoujdA:active {
    cursor: grabbing;
}

.DeK7fBza7sb1DUnnF4B1 {
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5;
    color: #262626;
    transition: color 0.2s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.DeK7fBza7sb1DUnnF4B1:hover {
    color: #1890ff;
}

.EETIE7BdhOHbMlaQsGR6 {
    display: flex;
    align-items: center;
    gap: 4px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.lXP0bWPL5ESHwJzG_h7X:hover .EETIE7BdhOHbMlaQsGR6 {
    opacity: 1;
}

.QUskCkY16hVXMZtTmHfg {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 6px;
    cursor: pointer;
    background-color: transparent;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 12px;
}

.QUskCkY16hVXMZtTmHfg:first-child {
    color: #1890ff;
    font-weight: bold;
    font-size: 14px;
}

.QUskCkY16hVXMZtTmHfg:first-child:hover {
    background-color: #e6f7ff;
    color: #1890ff;
    transform: scale(1.1);
}

.QUskCkY16hVXMZtTmHfg:nth-child(2) {
    color: #52c41a;
}

.QUskCkY16hVXMZtTmHfg:nth-child(2):hover {
    background-color: #f6ffed;
    color: #52c41a;
    transform: scale(1.1);
}

.QUskCkY16hVXMZtTmHfg:last-child {
    color: #ff4d4f;
}

.QUskCkY16hVXMZtTmHfg:last-child:hover {
    background-color: #fff2f0;
    color: #ff4d4f;
    transform: scale(1.1);
}

.QUskCkY16hVXMZtTmHfg:active {
    transform: scale(0.95);
}

/* Стили для иерархии */
.ui_PQgyTRSDKhW9RqPmQ {
    margin-left: 20px;
    padding-left: 16px;
    border-left: 2px solid #f0f0f0;
    overflow: hidden;
    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
    position: relative;
}

.ui_PQgyTRSDKhW9RqPmQ::before {
    content: '';
    position: absolute;
    left: -2px;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(to bottom, #1890ff, #69c0ff);
    transform: scaleY(0);
    transform-origin: top;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.ui_PQgyTRSDKhW9RqPmQ:hover::before {
    transform: scaleY(1);
}

.zSlovgrZYDbpTqv68urA {
    position: relative;
}

.JH6d_xdQiGmpEAAJizpy {
    position: absolute;
    left: -18px;
    top: 16px;
    width: 16px;
    height: 2px;
    background: linear-gradient(to right, #f0f0f0, #d9d9d9);
    border-radius: 1px;
}

.jHdqr_JfTgRRpiJNYAh4 {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #f0f0f0;
}

/* Стили для перетаскивания */
.lXP0bWPL5ESHwJzG_h7X.ohXHvzyF3NOXio96vap1 {
    opacity: 0.6;
    transform: rotate(2deg) scale(1.02);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.12);
    border: 2px dashed #1890ff;
    background: linear-gradient(135deg, #e6f7ff, #f0f7ff);
}

.lXP0bWPL5ESHwJzG_h7X.F9RmIOCe81OnFYdJcac6 {
    border: 2px solid #1890ff;
    background: linear-gradient(135deg, #e6f7ff, #ffffff);
    transform: scale(1.02);
}

._1kjEmoCzCj2clyNNro0J {
    margin-top: 20px;
  }
  
  .YZqqWNVS3z93BWfHcGc1 {
    width: 100%;
    padding: 8px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .XHfXiNXwepTX3bXkMDtl {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 300px; /* Ограничение высоты списка */
    overflow-y: auto; /* Включение прокрутки по вертикали */
    border: 1px solid #ddd; /* Дополнительное оформление для визуального ограничения */
    border-radius: 5px;
  }
  
  .v4EsBdIizKHtJM7mrm6T {
    padding: 10px;
    margin-bottom: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    cursor: pointer;
    background-color: #ffffff;
    transition: background-color 0.3s;
  }
  
  .v4EsBdIizKHtJM7mrm6T:hover {
    background-color: #f1f1f1;
  }
  
  .YEghHdgr7eMADjHwWCDQ {
    padding: 10px 20px;
    background-color: #007bff;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .YEghHdgr7eMADjHwWCDQ:hover {
    background-color: #0056b3;
  }

.GdmgVi2VQRpUqqTweJMN {
    margin-left: 20px;
}

.TN9YlaQqwxC6WgNnCaQw {
    margin-left: 10px;
    cursor: pointer;
    color: #007bff;
}

.TN9YlaQqwxC6WgNnCaQw:hover {
    color: #0056b3;
}

.JJABjgSVxpAC1MkRiZTH {
  cursor: pointer;
  margin-left: 10px;
  color: #1890ff;
  transition: color 0.3s;
}

.JJABjgSVxpAC1MkRiZTH:hover {
  color: #40a9ff;
}

.CvJ10SGkmj3LxRvkNNdW {
    border: 2px solid #1890ff !important;
    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1), 0 4px 12px rgba(24, 144, 255, 0.15) !important;
    background: linear-gradient(135deg, #f0f7ff, #ffffff) !important;
}

.CvJ10SGkmj3LxRvkNNdW .DeK7fBza7sb1DUnnF4B1 {
    color: #1890ff;
    font-weight: 600;
}

.JKuYuVXd0toYyQefjHQr {
    cursor: pointer;
    color: #8c8c8c;
    font-size: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 4px;
    padding: 4px;
}

.JKuYuVXd0toYyQefjHQr:hover {
    color: #1890ff;
    background-color: #f0f7ff;
    transform: scale(1.1);
}

.uxFdJCEKEo3RFhmTxhsd {
    transform: rotate(90deg);
    color: #1890ff;
}

.IGmKWDrnXXIHm3DxfxeR {
    max-height: 0;
    opacity: 0;
    margin-top: 0;
}

.S46hwdXY6ZamjlQLxviR {
    max-height: none;
    opacity: 1;
    margin-top: 8px;
}

/* Анимации для производительности */
.lXP0bWPL5ESHwJzG_h7X {
    will-change: transform, box-shadow;
}

.lXP0bWPL5ESHwJzG_h7X * {
    will-change: auto;
}

/* Поддержка reduce-motion */
@media (prefers-reduced-motion: reduce) {
    .lXP0bWPL5ESHwJzG_h7X,
    .JKuYuVXd0toYyQefjHQr,
    .QUskCkY16hVXMZtTmHfg,
    .ui_PQgyTRSDKhW9RqPmQ {
        transition: none;
    }
    
    .lXP0bWPL5ESHwJzG_h7X:hover {
        transform: none;
    }
    
    .QUskCkY16hVXMZtTmHfg:hover {
        transform: none;
    }
    
    .JKuYuVXd0toYyQefjHQr:hover {
        transform: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsWindow/ChecklistInListItem.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,mBAAmB;IACnB,kBAAkB;IAClB,wEAAwE;IACxE,iDAAiD;IACjD,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yEAAyE;IACzE,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,2EAA2E;IAC3E,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,UAAU;IACV,wDAAwD;IACxD,oBAAoB;IACpB,qBAAqB;IACrB,uDAAuD;AAC3D;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;IACX,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,6BAA6B;AAC7B;IACI,YAAY;IACZ,mCAAmC;IACnC,0EAA0E;IAC1E,0BAA0B;IAC1B,qDAAqD;AACzD;;AAEA;IACI,yBAAyB;IACzB,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,iBAAiB,EAAE,8BAA8B;IACjD,gBAAgB,EAAE,qCAAqC;IACvD,sBAAsB,EAAE,0DAA0D;IAClF,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,oCAAoC;IACpC,6FAA6F;IAC7F,gEAAgE;AACpE;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,iDAAiD;IACjD,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA,oCAAoC;AACpC;IACI,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;AACrB;;AAEA,4BAA4B;AAC5B;IACI;;;;QAII,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/* Современный карточный дизайн */\n.checklistCard {\n    margin-bottom: 12px;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.12);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    cursor: move;\n    border: 1px solid #f0f0f0;\n}\n\n.checklistCard:hover {\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);\n    transform: translateY(-1px);\n    border-color: #d9d9d9;\n}\n\n.cardHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.headerLeft {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n}\n\n.headerRight {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.dragHandle {\n    color: #bfbfbf;\n    cursor: grab;\n    margin-right: 8px;\n    transition: color 0.2s ease;\n}\n\n.dragHandle:hover {\n    color: #8c8c8c;\n}\n\n.dragHandle:active {\n    cursor: grabbing;\n}\n\n.checklistName {\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 1.5;\n    color: #262626;\n    transition: color 0.2s ease;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1;\n    min-width: 0;\n}\n\n.checklistName:hover {\n    color: #1890ff;\n}\n\n.checklistActions {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n}\n\n.checklistCard:hover .checklistActions {\n    opacity: 1;\n}\n\n.actionButton {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: transparent;\n    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n    font-size: 12px;\n}\n\n.actionButton:first-child {\n    color: #1890ff;\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.actionButton:first-child:hover {\n    background-color: #e6f7ff;\n    color: #1890ff;\n    transform: scale(1.1);\n}\n\n.actionButton:nth-child(2) {\n    color: #52c41a;\n}\n\n.actionButton:nth-child(2):hover {\n    background-color: #f6ffed;\n    color: #52c41a;\n    transform: scale(1.1);\n}\n\n.actionButton:last-child {\n    color: #ff4d4f;\n}\n\n.actionButton:last-child:hover {\n    background-color: #fff2f0;\n    color: #ff4d4f;\n    transform: scale(1.1);\n}\n\n.actionButton:active {\n    transform: scale(0.95);\n}\n\n/* Стили для иерархии */\n.subChecklistContainer {\n    margin-left: 20px;\n    padding-left: 16px;\n    border-left: 2px solid #f0f0f0;\n    overflow: hidden;\n    transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;\n    position: relative;\n}\n\n.subChecklistContainer::before {\n    content: '';\n    position: absolute;\n    left: -2px;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    background: linear-gradient(to bottom, #1890ff, #69c0ff);\n    transform: scaleY(0);\n    transform-origin: top;\n    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.subChecklistContainer:hover::before {\n    transform: scaleY(1);\n}\n\n.subChecklistItem {\n    position: relative;\n}\n\n.subChecklistConnector {\n    position: absolute;\n    left: -18px;\n    top: 16px;\n    width: 16px;\n    height: 2px;\n    background: linear-gradient(to right, #f0f0f0, #d9d9d9);\n    border-radius: 1px;\n}\n\n.subForm {\n    margin-top: 12px;\n    padding-top: 12px;\n    border-top: 1px solid #f0f0f0;\n}\n\n/* Стили для перетаскивания */\n.checklistCard.isDragging {\n    opacity: 0.6;\n    transform: rotate(2deg) scale(1.02);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.12);\n    border: 2px dashed #1890ff;\n    background: linear-gradient(135deg, #e6f7ff, #f0f7ff);\n}\n\n.checklistCard.isOver {\n    border: 2px solid #1890ff;\n    background: linear-gradient(135deg, #e6f7ff, #ffffff);\n    transform: scale(1.02);\n}\n\n.checklistForm {\n    margin-top: 20px;\n  }\n  \n  .inputField {\n    width: 100%;\n    padding: 8px;\n    margin-bottom: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  .fieldList {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    max-height: 300px; /* Ограничение высоты списка */\n    overflow-y: auto; /* Включение прокрутки по вертикали */\n    border: 1px solid #ddd; /* Дополнительное оформление для визуального ограничения */\n    border-radius: 5px;\n  }\n  \n  .fieldItem {\n    padding: 10px;\n    margin-bottom: 5px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: #ffffff;\n    transition: background-color 0.3s;\n  }\n  \n  .fieldItem:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .createButton {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #ffffff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .createButton:hover {\n    background-color: #0056b3;\n  }\n\n.subItem {\n    margin-left: 20px;\n}\n\n.checklistMoveButton {\n    margin-left: 10px;\n    cursor: pointer;\n    color: #007bff;\n}\n\n.checklistMoveButton:hover {\n    color: #0056b3;\n}\n\n.moveButton {\n  cursor: pointer;\n  margin-left: 10px;\n  color: #1890ff;\n  transition: color 0.3s;\n}\n\n.moveButton:hover {\n  color: #40a9ff;\n}\n\n.selected {\n    border: 2px solid #1890ff !important;\n    box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1), 0 4px 12px rgba(24, 144, 255, 0.15) !important;\n    background: linear-gradient(135deg, #f0f7ff, #ffffff) !important;\n}\n\n.selected .checklistName {\n    color: #1890ff;\n    font-weight: 600;\n}\n\n.toggleIcon {\n    cursor: pointer;\n    color: #8c8c8c;\n    font-size: 12px;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    border-radius: 4px;\n    padding: 4px;\n}\n\n.toggleIcon:hover {\n    color: #1890ff;\n    background-color: #f0f7ff;\n    transform: scale(1.1);\n}\n\n.expandedIcon {\n    transform: rotate(90deg);\n    color: #1890ff;\n}\n\n.collapsed {\n    max-height: 0;\n    opacity: 0;\n    margin-top: 0;\n}\n\n.expanded {\n    max-height: none;\n    opacity: 1;\n    margin-top: 8px;\n}\n\n/* Анимации для производительности */\n.checklistCard {\n    will-change: transform, box-shadow;\n}\n\n.checklistCard * {\n    will-change: auto;\n}\n\n/* Поддержка reduce-motion */\n@media (prefers-reduced-motion: reduce) {\n    .checklistCard,\n    .toggleIcon,\n    .actionButton,\n    .subChecklistContainer {\n        transition: none;\n    }\n    \n    .checklistCard:hover {\n        transform: none;\n    }\n    \n    .actionButton:hover {\n        transform: none;\n    }\n    \n    .toggleIcon:hover {\n        transform: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checklistCard": `lXP0bWPL5ESHwJzG_h7X`,
	"cardHeader": `sfJNS4IUruQQ0jXHttPI`,
	"headerLeft": `_ghhA8P__OyCGB4hZ8cV`,
	"headerRight": `h3szAdLROrv29YHjSwO6`,
	"dragHandle": `xP9yEveWlOy8IJfoujdA`,
	"checklistName": `DeK7fBza7sb1DUnnF4B1`,
	"checklistActions": `EETIE7BdhOHbMlaQsGR6`,
	"actionButton": `QUskCkY16hVXMZtTmHfg`,
	"subChecklistContainer": `ui_PQgyTRSDKhW9RqPmQ`,
	"subChecklistItem": `zSlovgrZYDbpTqv68urA`,
	"subChecklistConnector": `JH6d_xdQiGmpEAAJizpy`,
	"subForm": `jHdqr_JfTgRRpiJNYAh4`,
	"isDragging": `ohXHvzyF3NOXio96vap1`,
	"isOver": `F9RmIOCe81OnFYdJcac6`,
	"checklistForm": `_1kjEmoCzCj2clyNNro0J`,
	"inputField": `YZqqWNVS3z93BWfHcGc1`,
	"fieldList": `XHfXiNXwepTX3bXkMDtl`,
	"fieldItem": `v4EsBdIizKHtJM7mrm6T`,
	"createButton": `YEghHdgr7eMADjHwWCDQ`,
	"subItem": `GdmgVi2VQRpUqqTweJMN`,
	"checklistMoveButton": `TN9YlaQqwxC6WgNnCaQw`,
	"moveButton": `JJABjgSVxpAC1MkRiZTH`,
	"selected": `CvJ10SGkmj3LxRvkNNdW`,
	"toggleIcon": `JKuYuVXd0toYyQefjHQr`,
	"expandedIcon": `uxFdJCEKEo3RFhmTxhsd`,
	"collapsed": `IGmKWDrnXXIHm3DxfxeR`,
	"expanded": `S46hwdXY6ZamjlQLxviR`
};
export default ___CSS_LOADER_EXPORT___;
